const GlobalSearchTabs = {
    GAMES: 'games',
    SPORTS: 'sports'
}

export {
    GlobalSearchTabs
};